import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AlertService, AuthenticationService } from 'src/app/shared/_services';
import { UpgradeStore } from 'src/app/shared/_services/store/upgradeStore.service';

@Component({
  selector: 'app-upgrade-form',
  templateUrl: './upgrade-form.component.html',
  styleUrls: ['./../upgrade-account.page.scss'],
})
export class UpgradeFormComponent implements OnInit, DoCheck {
  placeholderText = 'Upload File';
  fileName: string;
  fileNameTruncated: string;
  tierIdentifier: string;
  base64String = '';
  disabled = true;
  continue = false;
  hideSpinner = true;
  isRegistered = false;
  isGold = false;
  isStep2 = false;
  fileSize = 5120000;
  fileFormats = '.png, .jpeg, .jpg, .pdf';
  supportInfo = 'Supports JPG, PNG, PDF files only. Max size - 5MB';
  accountDocumentStatus = this.upgradeStore.getAccountDocumentStatus();
  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  ids = [
    {
      name: 'National Identity Card/Slip',
      value: 'NATIONAL_IDENTITY_CARD',
    },
    {
      name: 'International Passport',
      value: 'INTERNATIONAL_PASSPORT',
    },
    {
      name: 'Driver\'s License',
      value: 'DRIVERS_LICENSE',
    },
    {
      name: 'Voter\'s Card',
      value: 'VOTERS_CARD',
    },
  ];

  businessClasses = ['PLC', 'LTD', 'BUSINESS_NAME'];
  bills = ['Electricity Bill', 'Waste Bill', 'Water Supply Bill'];

  id = {
    heading: 'Valid Government Issued ID',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    type: '',
    payload: {
      DocumentType: 'identification',
      FileName: '',
      Image: '',
    },
  };

  bill = {
    heading: 'Utility Bill',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'utilityBill',
      FileName: '',
      Image: '',
    },
  };

  photo = {
    heading: 'Photo',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'passport',
      FileName: '',
      Image: '',
    },
  };

  cert = {
    heading: 'Certificate of Incorporation',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'certificate',
      FileName: '',
      Image: '',
    },
  };

  cacForm2 = {
    heading: 'CAC Form 2',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'formCO2',
      FileName: '',
      Image: '',
    },
  };

  cacForm7 = {
    heading: 'CAC Form 7',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'formCO7',
      FileName: '',
      Image: '',
    },
  };

  // Platinum
  memart = {
    heading: 'Memorandum of Articles and Association',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    type: '',
    payload: {
      DocumentType: 'memart',
      FileName: '',
      Image: '',
    },
  };

  directorId = {
    heading: 'Valid Government Issued ID',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    type: '',
    payload: {
      DocumentType: 'directorId',
      FileName: '',
      Image: '',
    },
  };

  directorBill = {
    heading: 'Utility Bill',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'directorUtilityBill',
      FileName: '',
      Image: '',
    },
  };

  directorPhoto = {
    heading: 'Photo',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'directorPassport',
      FileName: '',
      Image: '',
    },
  };

  shareholderId = {
    heading: 'Valid Government Issued ID',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    type: '',
    payload: {
      DocumentType: 'principalShareholderId',
      FileName: '',
      Image: '',
    },
  };

  shareholderBill = {
    heading: 'Utility Bill',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'principalShareholderUtilityBill',
      FileName: '',
      Image: '',
    },
  };

  shareholderPhoto = {
    heading: 'Photo',
    placeholder: this.placeholderText,
    isSupported: null,
    isLess: null,
    status: '',
    payload: {
      DocumentType: 'principalShareholderPassport',
      FileName: '',
      Image: '',
    },
  };

  directorNumbers = {
    Bvn: {
      containsNonDigits: '',
      digitsLength: '',
    },
    Nin: {
      containsNonDigits: '',
      digitsLength: '',
    },
  };

  shareholderNumbers = {
    Bvn: {
      containsNonDigits: '',
      digitsLength: '',
    },
    Nin: {
      containsNonDigits: '',
      digitsLength: '',
    },
  };

  goldIndividualForm = {
    MerchantId: this.currentUser.details.id,
    FirstName: '',
    LastName: '',
    Gender: '',
    IdType: '',
    Nin: '',
    AccountIds: this.upgradeStore.getRequestId() === 'null' ? this.upgradeStore.getSelectedIds() : [],
    AccountIdIsNull: this.upgradeStore.getSelectedIds() ? this.upgradeStore.getSelectedIds().includes(null) : false,
    AccountUpgradeRequestId:
      this.upgradeStore.getRequestId() === 'null'
        ? null
        : parseInt(this.upgradeStore.getRequestId(), 10),
  };

  goldBusinessForm = {
    ...this.goldIndividualForm,
    Type: '',
  };

  platinumForm = {
    ...this.goldBusinessForm,
    Director: {
      Bvn: '',
      Nin: '',
    },
    PrincipalShareholder: {
      Bvn: '',
      Nin: '',
    },
  };

  public errorMessages = {
    isSupported: 'Format not supported. Please upload a valid file',
    isLess: 'File is too large. Please upload a file not larger than 5MB',
    containsNonDigits: '',
    digitsLength: '',
  };
  isVerified: boolean;

  constructor(
    private router: Router,
    private platform: Platform,
    private upgradeStore: UpgradeStore,
    private alertService: AlertService,
    private auth: AuthenticationService
  ) {}

  goBack() {
    this.router.navigateByUrl('/upgrade-account');
    this.isRegistered = false;
  }

  goToStep2() {
    this.isStep2 = !this.isStep2;
  }

  getIdType(id: string) {
    console.log('Value', id);
    this.id.payload.DocumentType = id;
    this.goldIndividualForm.IdType = id;
    this.goldBusinessForm.IdType = id;
    this.id.type = id.toLowerCase().split('_').join(' ');
    this.upgradeStore.setIdType(id.toLowerCase().split('_').join(' '));
  }

  getBusinessClass(businessClass: string) {
    console.log('Value', businessClass);
    this.goldBusinessForm.Type = businessClass;
    this.platinumForm.Type = businessClass;
  }

  getGender(e: any) {
    this.goldIndividualForm.Gender = e.target.value;
  }

  inputNumbers(e: any) {
    console.log(e.target.id);
    const isInteger = /^[0-9]+$/;
    const containsNonDigits = 'Please enter only digits';
    const digitsLength = 'Please enter 11 digits';
    if (e.target.id === 'gold-nin') {
      this.goldIndividualForm.Nin = e.target.value;
      this.goldBusinessForm.Nin = e.target.value;
      if (
        this.goldIndividualForm.Nin.match(isInteger) !== null ||
        this.goldBusinessForm.Nin.match(isInteger) !== null
      ) {
        this.errorMessages.containsNonDigits = '';
      } else {
        this.errorMessages.containsNonDigits = containsNonDigits;
      }
      if (
        this.goldIndividualForm.Nin.length !== 11 ||
        this.goldBusinessForm.Nin.length !== 11
      ) {
        this.errorMessages.digitsLength = digitsLength;
      } else {
        this.errorMessages.digitsLength = '';
      }
    } else if (e.target.id === 'dir-bvn') {
      this.platinumForm.Director.Bvn = e.target.value;
      if (this.platinumForm.Director.Bvn.match(isInteger) !== null) {
        this.directorNumbers.Bvn.containsNonDigits = '';
      } else {
        this.directorNumbers.Bvn.containsNonDigits = containsNonDigits;
      }
      if (this.platinumForm.Director.Bvn.length !== 11) {
        this.directorNumbers.Bvn.digitsLength = digitsLength;
      } else {
        this.directorNumbers.Bvn.digitsLength = '';
        this.validateBvn(e.target.value);
      }
    } else if (e.target.id === 'dir-nin') {
      this.platinumForm.Director.Nin = e.target.value;
      if (this.platinumForm.Director.Nin.match(isInteger) !== null) {
        this.directorNumbers.Nin.containsNonDigits = '';
      } else {
        this.directorNumbers.Nin.containsNonDigits = containsNonDigits;
      }
      if (this.platinumForm.Director.Nin.length !== 11) {
        this.directorNumbers.Nin.digitsLength = digitsLength;
      } else {
        this.directorNumbers.Nin.digitsLength = '';
      }
    } else if (e.target.id === 'share-bvn') {
      this.platinumForm.PrincipalShareholder.Bvn = e.target.value;
      if (
        this.platinumForm.PrincipalShareholder.Bvn.match(isInteger) !== null
      ) {
        this.shareholderNumbers.Bvn.containsNonDigits = '';
      } else {
        this.shareholderNumbers.Bvn.containsNonDigits = containsNonDigits;
      }
      if (this.platinumForm.PrincipalShareholder.Bvn.length !== 11) {
        this.shareholderNumbers.Bvn.digitsLength = digitsLength;
      } else {
        this.shareholderNumbers.Bvn.digitsLength = '';
        this.validateBvn(e.target.value);
      }
    } else if (e.target.id === 'share-nin') {
      this.platinumForm.PrincipalShareholder.Nin = e.target.value;
      if (
        this.platinumForm.PrincipalShareholder.Nin.match(isInteger) !== null
      ) {
        this.shareholderNumbers.Nin.containsNonDigits = '';
      } else {
        this.shareholderNumbers.Nin.containsNonDigits = containsNonDigits;
      }
      if (this.platinumForm.PrincipalShareholder.Nin.length !== 11) {
        this.shareholderNumbers.Nin.digitsLength = digitsLength;
      } else {
        this.shareholderNumbers.Nin.digitsLength = '';
      }
    }
  }

  validateBvn(bvn) {
    if (bvn.length === 11) {
      this.alertService.loading('Verifying BVN...');
      this.auth.getBvn2(bvn).subscribe(
        (response: any) => {
          console.log(response);
          if (response.responseCode === '00') {
            this.isVerified = true;
            this.alertService.stopLoading();
            this.alertService.standardAlertWithButton(
              response.responseDescription,
              response.responseObject.firstName +
                ' ' +
                response.responseObject.middleName +
                ' ' +
                response.responseObject.lastName,
              true,
              'Ok'
            );
          } else if (response.responseCode === '96') {
            this.alertService.standardAlert(
              'Failed. Please try again'
            );
            this.isVerified = false;
            this.alertService.stopLoading();
            this.alertService.standardAlertWithButton(
              'Error Validating BVN',
              '',
              true,
              'Ok'
            );
          } else if (response.status >= 400 && response.status <= 500) {
            this.alertService.standardAlert(
              'BVN service is currently unavailable. Please try again'
            );
          } else {
            this.alertService.standardAlert(
              'Failed. Please try again'
            );
          }
        },
        (err) => {
          console.log(err);
          this.isVerified = false;
          this.alertService.stopLoading();
          this.alertService.standardAlert(
            'Failed. Please check your BVN and try again.<br/> If problem persists, please be patient. ' +
            'Service would be restored soon'
          );
        }
      );
    }
  }

  isIdValid() {
    if (
      this.id.payload.Image.length > 0 &&
      (this.id.isSupported && this.id.isLess) === true
    ) {
      return true;
    }
  }

  isBillValid() {
    if (
      this.bill.payload.Image.length > 0 &&
      (this.bill.isSupported && this.bill.isLess) === true
    ) {
      return true;
    }
  }

  isPhotoValid() {
    if ((this.photo.isSupported && this.photo.isLess) === true) {
      return true;
    }
  }

  isMemartValid() {
    if ((this.memart.isSupported && this.memart.isLess) === true) {
      return true;
    }
  }

  isDirectorIdValid() {
    if (
      this.directorId.payload.Image.length > 0 &&
      (this.directorId.isSupported && this.directorId.isLess) === true
    ) {
      return true;
    }
  }

  isDirectorBillValid() {
    if (
      this.directorBill.payload.Image.length > 0 &&
      (this.directorBill.isSupported && this.directorBill.isLess) === true
    ) {
      return true;
    }
  }

  isDirectorPhotoValid() {
    if (
      (this.directorPhoto.isSupported && this.directorPhoto.isLess) === true
    ) {
      return true;
    }
  }

  isShareholderIdValid() {
    if (
      this.shareholderId.payload.Image.length > 0 &&
      (this.shareholderId.isSupported && this.shareholderId.isLess) === true
    ) {
      return true;
    }
  }

  isShareholderBillValid() {
    if (
      this.shareholderBill.payload.Image.length > 0 &&
      (this.shareholderBill.isSupported && this.shareholderBill.isLess) === true
    ) {
      return true;
    }
  }

  isShareholderPhotoValid() {
    if (
      (this.shareholderPhoto.isSupported && this.shareholderPhoto.isLess) ===
      true
    ) {
      return true;
    }
  }

  isCertValid() {
    if ((this.cert.isSupported && this.cert.isLess) === true) {
      return true;
    }
  }

  isCacForm2Valid() {
    if ((this.cacForm2.isSupported && this.cacForm2.isLess) === true) {
      return true;
    }
  }

  isCacForm7Valid() {
    if ((this.cacForm7.isSupported && this.cacForm7.isLess) === true) {
      return true;
    }
  }

  uploadId() {
    if (this.isIdValid()) {
      console.log(this.id.payload);
      this.uploadDocument(
        this.id.payload.DocumentType,
        this.id.payload.FileName,
        this.id.payload.Image,
        'Valid ID'
      );
    }
  }

  uploadBill() {
    if (this.isBillValid()) {
      console.log(this.bill.payload);
      this.uploadDocument(
        this.bill.payload.DocumentType,
        this.bill.payload.FileName,
        this.bill.payload.Image,
        'Utility Bill'
      );
    }
  }

  uploadPhoto() {
    if (this.isPhotoValid()) {
      console.log(this.photo.payload);
      this.uploadDocument(
        this.photo.payload.DocumentType,
        this.photo.payload.FileName,
        this.photo.payload.Image,
        'Photo'
      );
    }
  }

  uploadMemart() {
    if (this.isMemartValid()) {
      console.log(this.memart.payload);
      this.uploadDocument(
        this.memart.payload.DocumentType,
        this.memart.payload.FileName,
        this.memart.payload.Image,
        'Memorandum'
      );
    }
  }

  uploadDirectorId() {
    if (this.isDirectorIdValid()) {
      console.log(this.directorId.payload);
      this.uploadDocument(
        this.directorId.payload.DocumentType,
        this.directorId.payload.FileName,
        this.directorId.payload.Image,
        'Valid ID'
      );
    }
  }

  uploadDirectorBill() {
    if (this.isDirectorBillValid()) {
      console.log(this.directorBill.payload);
      this.uploadDocument(
        this.directorBill.payload.DocumentType,
        this.directorBill.payload.FileName,
        this.directorBill.payload.Image,
        'Utility Bill'
      );
    }
  }

  uploadDirectorPhoto() {
    if (this.isDirectorPhotoValid()) {
      console.log(this.directorPhoto.payload);
      this.uploadDocument(
        this.directorPhoto.payload.DocumentType,
        this.directorPhoto.payload.FileName,
        this.directorPhoto.payload.Image,
        'Photo'
      );
    }
  }

  uploadShareholderId() {
    if (this.isShareholderIdValid()) {
      console.log(this.shareholderId.payload);
      this.uploadDocument(
        this.shareholderId.payload.DocumentType,
        this.shareholderId.payload.FileName,
        this.shareholderId.payload.Image,
        'Valid ID'
      );
    }
  }

  uploadShareholderBill() {
    if (this.isShareholderBillValid()) {
      console.log(this.shareholderBill.payload);
      this.uploadDocument(
        this.shareholderBill.payload.DocumentType,
        this.shareholderBill.payload.FileName,
        this.shareholderBill.payload.Image,
        'Utility Bill'
      );
    }
  }

  uploadShareholderPhoto() {
    if (this.isShareholderPhotoValid()) {
      console.log(this.shareholderPhoto.payload);
      this.uploadDocument(
        this.shareholderPhoto.payload.DocumentType,
        this.shareholderPhoto.payload.FileName,
        this.shareholderPhoto.payload.Image,
        'Photo'
      );
    }
  }

  uploadCert() {
    if (this.isCertValid()) {
      console.log(this.cert.payload);
      this.uploadDocument(
        this.cert.payload.DocumentType,
        this.cert.payload.FileName,
        this.cert.payload.Image,
        'Certificate'
      );
    }
  }

  uploadCacForm2() {
    if (this.isCacForm2Valid()) {
      console.log(this.cacForm2.payload);
      this.uploadDocument(
        this.cacForm2.payload.DocumentType,
        this.cacForm2.payload.FileName,
        this.cacForm2.payload.Image,
        this.cacForm2.heading
      );
    }
  }

  uploadCacForm7() {
    if (this.isCacForm7Valid()) {
      console.log(this.cacForm7.payload);
      this.uploadDocument(
        this.cacForm7.payload.DocumentType,
        this.cacForm7.payload.FileName,
        this.cacForm7.payload.Image,
        this.cacForm7.heading
      );
    }
  }

  uploadFile(e: any) {
    this.fileNameTruncated = e.target.value.substring(12);
    const file = e.target.files[0];
    console.log(file);
    if (file) {
      const formats = ['png', 'jpg', 'jpeg', 'pdf'];
      const acceptedFormat = formats.filter((format) =>
        file.type.includes(format)
      );
      const reader = new FileReader();
      reader.onloadend = () => {
        this.base64String = reader.result
          .toString()
          .replace('data:', '')
          .replace(/^.+,/, '');

        // Personal
        if (e.target.id === 'tier-id') {
          this.id.payload.Image = this.base64String;
          this.id.payload.FileName = file.name;
          this.uploadId();
        } else if (e.target.id === 'tier-bill') {
          this.bill.payload.Image = this.base64String;
          this.bill.payload.FileName = file.name;
          this.uploadBill();
        } else if (e.target.id === 'tier-photo') {
          this.photo.payload.Image = this.base64String;
          this.photo.payload.FileName = file.name;
          this.uploadPhoto();

          // Memorandum
        } else if (e.target.id === 'tier-memart') {
          this.memart.payload.Image = this.base64String;
          this.memart.payload.FileName = file.name;
          this.uploadMemart();

          // Director
        } else if (e.target.id === 'tier-dir-id') {
          this.directorId.payload.Image = this.base64String;
          this.directorId.payload.FileName = file.name;
          this.uploadDirectorId();
        } else if (e.target.id === 'tier-dir-bill') {
          this.directorBill.payload.Image = this.base64String;
          this.directorBill.payload.FileName = file.name;
          this.uploadDirectorBill();
        } else if (e.target.id === 'tier-dir-photo') {
          this.directorPhoto.payload.Image = this.base64String;
          this.directorPhoto.payload.FileName = file.name;
          this.uploadDirectorPhoto();

          // Principal Shareholder
        } else if (e.target.id === 'tier-share-id') {
          this.shareholderId.payload.Image = this.base64String;
          this.shareholderId.payload.FileName = file.name;
          this.uploadShareholderId();
        } else if (e.target.id === 'tier-share-bill') {
          this.shareholderBill.payload.Image = this.base64String;
          this.shareholderBill.payload.FileName = file.name;
          this.uploadShareholderBill();
        } else if (e.target.id === 'tier-share-photo') {
          this.shareholderPhoto.payload.Image = this.base64String;
          this.shareholderPhoto.payload.FileName = file.name;
          this.uploadShareholderPhoto();

          // Certificates
        } else if (e.target.id === 'tier-cert') {
          this.cert.payload.Image = this.base64String;
          this.cert.payload.FileName = file.name;
          this.uploadCert();
        } else if (e.target.id === 'tier-cacForm2') {
          this.cacForm2.payload.Image = this.base64String;
          this.cacForm2.payload.FileName = file.name;
          this.uploadCacForm2();
        } else if (e.target.id === 'tier-cacForm7') {
          this.cacForm7.payload.Image = this.base64String;
          this.cacForm7.payload.FileName = file.name;
          this.uploadCacForm7();
        }
      };
      reader.readAsDataURL(file);
      if (acceptedFormat.length === 0) {
        if (e.target.id === 'tier-id') {
          this.id.isSupported = false;
        } else if (e.target.id === 'tier-bill') {
          this.bill.isSupported = false;
        } else if (e.target.id === 'tier-photo') {
          this.photo.isSupported = false;
        } else if (e.target.id === 'tier-memart') {
          this.memart.isSupported = false;
        } else if (e.target.id === 'tier-dir-id') {
          this.directorId.isSupported = false;
        } else if (e.target.id === 'tier-dir-bill') {
          this.directorBill.isSupported = false;
        } else if (e.target.id === 'tier-dir-photo') {
          this.directorPhoto.isSupported = false;
        } else if (e.target.id === 'tier-share-id') {
          this.shareholderId.isSupported = false;
        } else if (e.target.id === 'tier-share-bill') {
          this.shareholderBill.isSupported = false;
        } else if (e.target.id === 'tier-share-photo') {
          this.shareholderPhoto.isSupported = false;
        } else if (e.target.id === 'tier-cert') {
          this.cert.isSupported = false;
        } else if (e.target.id === 'tier-cacForm2') {
          this.cacForm2.isSupported = false;
        } else if (e.target.id === 'tier-cacForm7') {
          this.cacForm7.isSupported = false;
        }
      } else {
        if (e.target.id === 'tier-id') {
          this.id.isSupported = true;
        } else if (e.target.id === 'tier-bill') {
          this.bill.isSupported = true;
        } else if (e.target.id === 'tier-photo') {
          this.photo.isSupported = true;
        } else if (e.target.id === 'tier-memart') {
          this.memart.isSupported = true;
        } else if (e.target.id === 'tier-dir-id') {
          this.directorId.isSupported = true;
        } else if (e.target.id === 'tier-dir-bill') {
          this.directorBill.isSupported = true;
        } else if (e.target.id === 'tier-dir-photo') {
          this.directorPhoto.isSupported = true;
        } else if (e.target.id === 'tier-share-id') {
          this.shareholderId.isSupported = true;
        } else if (e.target.id === 'tier-share-bill') {
          this.shareholderBill.isSupported = true;
        } else if (e.target.id === 'tier-share-photo') {
          this.shareholderPhoto.isSupported = true;
        } else if (e.target.id === 'tier-cert') {
          this.cert.isSupported = true;
        } else if (e.target.id === 'tier-cacForm2') {
          this.cacForm2.isSupported = true;
        } else if (e.target.id === 'tier-cacForm7') {
          this.cacForm7.isSupported = true;
        }
      }

      if (file.size > this.fileSize) {
        if (e.target.id === 'tier-id') {
          this.id.isLess = false;
        } else if (e.target.id === 'tier-bill') {
          this.bill.isLess = false;
        } else if (e.target.id === 'tier-photo') {
          this.photo.isLess = false;
        } else if (e.target.id === 'tier-memart') {
          this.memart.isLess = false;
        } else if (e.target.id === 'tier-dir-id') {
          this.directorId.isLess = false;
        } else if (e.target.id === 'tier-dir-bill') {
          this.directorBill.isLess = false;
        } else if (e.target.id === 'tier-dir-photo') {
          this.directorPhoto.isLess = false;
        } else if (e.target.id === 'tier-share-id') {
          this.shareholderId.isLess = false;
        } else if (e.target.id === 'tier-share-bill') {
          this.shareholderBill.isLess = false;
        } else if (e.target.id === 'tier-share-photo') {
          this.shareholderPhoto.isLess = false;
        } else if (e.target.id === 'tier-cert') {
          this.cert.isLess = false;
        } else if (e.target.id === 'tier-cacForm2') {
          this.cacForm2.isLess = false;
        } else if (e.target.id === 'tier-cacForm7') {
          this.cacForm7.isLess = false;
        }
      } else {
        if (e.target.id === 'tier-id') {
          this.id.isLess = true;
        } else if (e.target.id === 'tier-bill') {
          this.bill.isLess = true;
        } else if (e.target.id === 'tier-photo') {
          this.photo.isLess = true;
        } else if (e.target.id === 'tier-memart') {
          this.memart.isLess = true;
        } else if (e.target.id === 'tier-dir-id') {
          this.directorId.isLess = true;
        } else if (e.target.id === 'tier-dir-bill') {
          this.directorBill.isLess = true;
        } else if (e.target.id === 'tier-dir-photo') {
          this.directorPhoto.isLess = true;
        } else if (e.target.id === 'tier-share-id') {
          this.shareholderId.isLess = true;
        } else if (e.target.id === 'tier-share-bill') {
          this.shareholderBill.isLess = true;
        } else if (e.target.id === 'tier-share-photo') {
          this.shareholderPhoto.isLess = true;
        } else if (e.target.id === 'tier-cert') {
          this.cert.isLess = true;
        } else if (e.target.id === 'tier-cacForm2') {
          this.cacForm2.isLess = true;
        } else if (e.target.id === 'tier-cacForm7') {
          this.cacForm7.isLess = true;
        }
      }
    }
    if (this.fileNameTruncated.length > 20) {
      this.fileName =
        this.fileNameTruncated.slice(0, 25) +
        '... ' +
        this.fileNameTruncated.slice(-4);
    } else {
      this.fileName = this.fileNameTruncated;
    }
    if (e.target.id === 'tier-id') {
      this.id.placeholder = this.fileName;
      this.id.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.id.placeholder = this.placeholderText;
      }
      if (this.id.placeholder === this.placeholderText) {
        this.id.payload.Image = '';
      }
    } else if (e.target.id === 'tier-bill') {
      this.bill.placeholder = this.fileName;
      this.bill.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.bill.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-photo') {
      this.photo.placeholder = this.fileName;
      this.photo.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.photo.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-memart') {
      this.memart.placeholder = this.fileName;
      this.memart.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.memart.placeholder = this.placeholderText;
      }
      if (this.memart.placeholder === this.placeholderText) {
        this.memart.payload.Image = '';
      }
    } else if (e.target.id === 'tier-dir-id') {
      this.directorId.placeholder = this.fileName;
      this.directorId.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.directorId.placeholder = this.placeholderText;
      }
      if (this.directorId.placeholder === this.placeholderText) {
        this.directorId.payload.Image = '';
      }
    } else if (e.target.id === 'tier-dir-bill') {
      this.directorBill.placeholder = this.fileName;
      this.directorBill.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.directorBill.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-dir-photo') {
      this.directorPhoto.placeholder = this.fileName;
      this.directorPhoto.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.directorPhoto.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-share-id') {
      this.shareholderId.placeholder = this.fileName;
      this.shareholderId.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.shareholderId.placeholder = this.placeholderText;
      }
      if (this.shareholderId.placeholder === this.placeholderText) {
        this.shareholderId.payload.Image = '';
      }
    } else if (e.target.id === 'tier-share-bill') {
      this.shareholderBill.placeholder = this.fileName;
      this.shareholderBill.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.shareholderBill.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-share-photo') {
      this.shareholderPhoto.placeholder = this.fileName;
      this.shareholderPhoto.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.shareholderPhoto.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-cert') {
      this.cert.placeholder = this.fileName;
      this.cert.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.cert.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-cacForm2') {
      this.cacForm2.placeholder = this.fileName;
      this.cacForm2.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.cacForm2.placeholder = this.placeholderText;
      }
    } else if (e.target.id === 'tier-cacForm7') {
      this.cacForm7.placeholder = this.fileName;
      this.cacForm7.payload.Image = this.base64String;
      if (this.fileNameTruncated.length === 0) {
        this.cacForm7.placeholder = this.placeholderText;
      }
    }
  }

  uploadDocument(
    DocumentType: string,
    FileName: string,
    Document: string,
    alertText: string
  ) {
    this.alertService.loading(
      'Uploading ' + alertText + '...<br/> This may take a few minutes'
    );
    this.auth
      .uploadDocument(
        DocumentType,
        FileName,
        Document,
        this.goldIndividualForm.AccountUpgradeRequestId
      )
      .subscribe(
        (response) => {
          this.alertService.stopLoading();
          this.alertService.standardAlert(alertText + ' uploaded succesfully');
          this.upgradeStore.getUpgradeStatus();
          console.log(response);
        },
        (error) => {
          this.alertService.stopLoading();
          this.alertService.retry(
            'Error uploading ' + alertText + '<br>' +
            error.error.ResponseDescription + '.<br>Please try again',
            null,
            true
          );
          console.log(error);
        }
      );
  }

  checkGoldFormValidity() {
    if (this.isRegistered || !this.isGold) {
      delete this.goldBusinessForm.FirstName;
      delete this.goldBusinessForm.LastName;
      delete this.goldBusinessForm.Gender;
      delete this.platinumForm.FirstName;
      delete this.platinumForm.LastName;
      delete this.platinumForm.Gender;
      delete this.platinumForm.IdType;
      delete this.platinumForm.Nin;
    }
    const isIndividualEmpty = Object.values(this.goldIndividualForm).find(
      (v) => v === ''
    );
    const isBusinessEmpty = Object.values(this.goldBusinessForm).find(
      (v) => v === ''
    );
    const isPlatinumEmpty = Object.values(this.platinumForm).find(
      (v) => v === ''
    );
    if (
      (!this.isRegistered && this.isGold && isIndividualEmpty === undefined &&
        this.goldIndividualForm.Nin.length === 11) ||
      (this.isRegistered && this.isGold && isBusinessEmpty === undefined &&
        this.goldBusinessForm.Nin.length === 11) ||
      (this.isRegistered && !this.isGold && isPlatinumEmpty === undefined &&
        this.platinumForm.Director.Bvn.length === 11 &&
        this.platinumForm.Director.Nin.length === 11 &&
        this.platinumForm.PrincipalShareholder.Bvn.length === 11 &&
        this.platinumForm.PrincipalShareholder.Nin.length === 11 &&
        this.isVerified
        )
    ) {
      this.continue = true;
    } else {
      this.continue = false;
    }
    if (!this.isRegistered && this.isGold && (this.id.status && this.bill.status && this.photo.status)) {
      this.disabled = false;
    } else if (this.isRegistered && this.isGold &&
      (this.id.status && this.bill.status && this.photo.status && this.cert.status)) {
        this.disabled = false;
    } else if (!this.isGold  && (this.directorId.status && this.directorBill.status && this.directorPhoto.status) &&
      (this.shareholderId.status && this.shareholderBill.status && this.shareholderPhoto.status)) {
      this.disabled = false;
    }
    // console.log(this.goldIndividualForm, this.goldBusinessForm);
  }

  modifySelectedIds() {
    const selectedIds = this.upgradeStore.getSelectedIds() ? this.upgradeStore.getSelectedIds() : [];
    const forms = [this.goldIndividualForm, this.goldBusinessForm, this.platinumForm];
    forms.forEach(form => {
      form.AccountIds = selectedIds.filter(
        (id: number) => id !== null
      );
      form.AccountIdIsNull = selectedIds.includes(null);
      form.AccountUpgradeRequestId =
        this.upgradeStore.getRequestId() === 'null'
          ? null
          : parseInt(this.upgradeStore.getRequestId(), 10);
    });
    // console.log(this.goldIndividualForm.AccountUpgradeRequestId, this.goldIndividualForm, this.goldBusinessForm, this.platinumForm);
  }

  makeUpgradeRequest() {
    let type = null;
    if (!this.isRegistered && this.isGold) {
      type = this.auth.upgradeGoldIndividual(this.goldIndividualForm);
    } else if (this.isRegistered && this.isGold) {
      type = this.auth.upgradeGoldBusiness(this.goldBusinessForm);
    } else if (!this.isGold) {
      type = this.auth.upgradePlatinum(this.platinumForm);
    }
    this.hideSpinner = !this.hideSpinner;
    this.continue = !this.continue;
    type.subscribe(
      (response: any) => {
        this.hideSpinner = !this.hideSpinner;
        this.continue = !this.continue;
        this.isStep2 = true;
        console.log(response);
        this.upgradeStore.setRequestId(response.AccountUpgradeRequestId);
        if (response.ResponseCode === '00') {
          this.alertService.standardAlert(
            'Successful! <br/> Please proceed to upload your documents'
          );
          this.upgradeStore.getUpgradeStatus();
        }
      },
      (error: any) => {
        this.hideSpinner = !this.hideSpinner;
        this.continue = !this.continue;
        this.alertService.standardAlert(error.error.ResponseDescription);
        console.log(error);
      }
    );
  }

  updateAccountDocumentStatus() {
    this.accountDocumentStatus = this.upgradeStore.getAccountDocumentStatus();
    this.accountDocumentStatus.forEach((element: any) => {
      console.log(element);
      this.id.status = element.Identification;
      this.id.type =
        element.IdType !== null
          ? element.IdType.split('_').join(' ').toLowerCase()
          : '';
      this.photo.status =
        element.Passport !== null
          ? element.Passport
          : '';
      this.bill.status =
        element.UtilityBill !== null
          ? element.UtilityBill
          : '';
      this.goldIndividualForm.Nin =
        element.Nin !== null
          ? element.Nin
          : '';
      this.goldBusinessForm.Nin =
        element.Nin !== null
          ? element.Nin
          : '';

      this.platinumForm.Director.Bvn =
        element.DirectorDTO !== null
          ? element.DirectorDTO.Bvn
          : '';
      this.platinumForm.Director.Nin =
        element.DirectorDTO !== null
          ? element.DirectorDTO.Nin
          : '';

      this.directorId.status =
        element.DirectorDTO !== null
          ? element.DirectorDTO.Identification
          : '';
      this.directorBill.status =
        element.DirectorDTO !== null
          ? element.DirectorDTO.UtilityBill
          : '';
      this.directorPhoto.status =
        element.DirectorDTO !== null
          ? element.DirectorDTO.Passport
          : '';

      this.platinumForm.PrincipalShareholder.Bvn =
        element.PrincipalShareholderDTO !== null
          ? element.PrincipalShareholderDTO.Bvn
          : '';
      this.platinumForm.PrincipalShareholder.Nin =
        element.PrincipalShareholderDTO !== null
          ? element.PrincipalShareholderDTO.Nin
          : '';

      this.shareholderId.status =
        element.PrincipalShareholderDTO !== null
          ? element.PrincipalShareholderDTO.Identification
          : '';
      this.shareholderBill.status =
        element.PrincipalShareholderDTO !== null
          ? element.PrincipalShareholderDTO.UtilityBill
          : '';
      this.shareholderPhoto.status =
        element.PrincipalShareholderDTO !== null
          ? element.PrincipalShareholderDTO.Passport
          : '';

      this.memart.status =
      element.BusinessDTO !== null
        ? element.BusinessDTO.Memart
        : '';
      this.cert.status =
        element.BusinessDTO !== null
          ? element.BusinessDTO.Certificate
          : '';
      this.cacForm2.status =
        element.BusinessDTO !== null
          ? element.BusinessDTO.Co2
          : '';
      this.cacForm7.status =
        element.BusinessDTO !== null
          ? element.BusinessDTO.Co7
          : '';
    });
  }

  submitForm() {
    this.hideSpinner = !this.hideSpinner;
    this.disabled = true;
    this.auth
      .upgradeAccount(this.goldBusinessForm.AccountUpgradeRequestId)
      .subscribe(
        (response: any) => {
          this.hideSpinner = !this.hideSpinner;
          this.disabled = !this.disabled;
          console.log(response);
          if (response.ResponseCode === '00') {
            this.alertService.standardAlertWithButton(
              'Account Upgrade Successful!',
              'Your <b>Approval Status</b> would be updated soon and your Upgrade would be completed soon. <br/>',
              true,
              'Go to Dashboard'
            );
            this.upgradeStore.setTempSelectedIds([]);
          }
        },
        (error) => {
          this.hideSpinner = !this.hideSpinner;
          this.disabled = !this.disabled;
          this.alertService.standardAlertNullDuration(
            error.error.ResponseDescription + '<br>Account Upgrade failed. Please try again'
          );
          console.log(error);
        }
      );
  }

  ngOnInit() {
    this.updateAccountDocumentStatus();
    if (this.upgradeStore.getIsUpgradeInfoDismissed() !== 'true') {
      this.alertService.standardAlertWithButton(
        '',
        '1. For a smooth and hassle free process, please ensure you have all documents before proceeding. <br/> <br/>' +
        '2. Please do not refresh during this process. <br/> <br/>' +
        '3. Large files take longer to upload. Not to worry, your file would still be uploaded. <br/> <br/>' +
        '4. Please submit after uploading your documents.',
        false,
        'Got it'
      );
    }
    if (this.isGold && this.accountDocumentStatus[0].Category.includes('3')) {
      this.alertService.standardAlertWithButton(
        '',
        'You are already upgrading or have upgraded to Platinum. <br>' +
        'No need to be here. You are now chilling with the big boys',
        false,
        'Got it'
      );
    }
  }

  ngDoCheck(): void {
    this.modifySelectedIds();
    this.checkGoldFormValidity();
    if (this.upgradeStore.getIsStatusOk() === 'true') {
      this.updateAccountDocumentStatus();
      this.upgradeStore.setIsStatusOk(false);
    }
    if (this.upgradeStore.getIsBusinessRegistered() === 'true') {
      this.isRegistered = true;
    } else {
      this.isRegistered = false;
    }
    if (location.pathname.includes('gold')) {
      this.isGold = true;
    }
    window.onpopstate = (() => {
      this.goBack();
    });
  }
}
